export enum ERole {
  Admin = 'admin',
  Doctor = 'doctor',
  Development = 'development'
}
